import startCase from 'lodash.startcase';
import { buttons as themeButtons } from '@theme/theme.buttons';

// can be used in any select field as its options
export const button = {
  options: [...Object.keys(themeButtons)]
    .filter((key) => !['link', 'plain'].includes(key))
    .map((key) => ({
      label: startCase(key),
      value: key,
    }))
    .sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    }),
  value: Object.keys(themeButtons).reduce((obj, key) => {
    obj[key] = key;
    return obj;
  }, {}),
};
